const PROYECTOS = [
    {
        name: 'Getyn',
        desde: '2021',
        hasta: 'hoy',
        descripcion: 'Getyn es una app mobile para comprar entradas para eventos. Ofrece distintas funciones, tanto para organizadores como clientes. Además, implementamos un sistema de match con otros participantes del evento al que asistirás.'
    }
]

export default function ProyectosComponent() {
    return (
        <div style={{padding:'20px'}}>
            {
                PROYECTOS.map((value, index) => <ItemProyecto key={`dsad-${index}`} data={value} />)
            }
        </div>
    )
}

const ItemProyecto = ({data}) => {
    return (
        <div>
            <div>

            </div>
            <div>
                <span style={{fontSize:'32px'}}>{data.name}</span> <span style={{color:'#6b6b6b', fontSize:'14px'}}>{data.desde} - {data.hasta}</span>
            </div>
            <div>{data.descripcion}</div>
        </div>
    )
}